import * as z from "zod/v4";

export const deleteShipmonkIntegration = {
  name: "deleteShipmonkIntegration" as const,
  input: z.object({}),
  output: z.object({}),
};
